import React from 'react';
import './Primary.styles.css';

export interface PrimaryProps {
  color: string;
  onClick?: React.MouseEventHandler;
}

export const Primary: React.FC<PrimaryProps> = ({ color, onClick }) => {
  return (
    <button onClick={onClick} className='voiting-man-icon '>
      <span className={`voiting-man-circle voiting-man-${color}`}></span>
      <span className={`voiting-man-rectangle voiting-man-${color}`}></span>
    </button>
  );
};
